export default __webpack_public_path__ + "static/media/flash10.15cb17d6.jpg";